import { ReactComponent as Facebook } from "icons/socialMedia/facebook.svg";
import { ReactComponent as Instagram } from "icons/socialMedia/instagram.svg";
import { ReactComponent as Snapchat } from "icons/socialMedia/snapchat.svg";
import { ReactComponent as Tiktok } from "icons/socialMedia/tiktok.svg";
import { ReactComponent as Twitter } from "icons/socialMedia/twitter.svg";
import { ReactComponent as Youtube } from "icons/socialMedia/youtube.svg";
import { FC, useEffect } from "react";

type SocialHandleProps = {
    socialHandles: Array<{
        id: string;
        username: string;
        user_id: string;
        created_at: string;
        updated_at: string;
        social_platforms_id: number;
    }>;
};

const SocialHandle: FC<SocialHandleProps> = ({ socialHandles }) => {
    // const [socialList, setSocialList] = useState();
    useEffect(() => {}, [socialHandles]);

    const listPredefined = [
        { value: 1, label: "instagram", icon: <Instagram /> },
        { value: 2, label: "youtube", icon: <Youtube /> },
        { value: 3, label: "facebook", icon: <Facebook /> },
        { value: 4, label: "snapchat", icon: <Snapchat /> },
        { value: 5, label: "twitter", icon: <Twitter /> },
        { value: 6, label: "tiktok", icon: <Tiktok /> },
    ];

    return (
        <>
            {socialHandles.length > 0 ? (
                <div style={{ display: "flex", gap: "1rem" }}>
                    {socialHandles.map((handle) => {
                        const platform = listPredefined.find(
                            (p) => p.value === handle.social_platforms_id
                        );
                        return platform ? (
                            <a
                                key={handle.id}
                                href={`https://www.${platform.label}.com/${handle.username}`}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                {platform.icon}
                            </a>
                        ) : null;
                    })}
                </div>
            ) : null}
        </>
    );
};

export default SocialHandle;
